module.exports = __webpack_public_path__ + "img/elephant.e1796090.svg";